module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Portfolios","portfolios":"Ihre Portfolios","noPortfolios":"Sie haben keine aktiven Portfolios","welcomeTitle":"Willkommen","portfoliosLoading":"Ihre Portfolios werden geladen","addPortfolio":"Portfolio erstellen","importPortfolio":"Portfolio importieren"}}')
  delete Component.options._Ctor
}
